import Footer from "../../component/Footer";
import { useState, useEffect } from "react";
import AgentNavbar from "../../component/AgentNavbar";
import $ from "jquery"; // Import jQuery
import "jquery-ui-dist/jquery-ui.css"; // Import jQuery UI CSS
import "jquery-ui-dist/jquery-ui.js"; // Import jQuery UI JS
import { baseurl } from "../../component/Baseurl";
import Select from "react-select"; // Import Select for dropdown
import { useNavigate } from "react-router-dom";


function BusBook() {
  const [departureDate, setDepartureDate] = useState(""); // Date of Journey state
  const [cities, setCities] = useState([]); // List of cities
  const [loading, setLoading] = useState(false); // Loading state
  const [selectedFrom, setSelectedFrom] = useState(null); // Selected 'From' city
  const [selectedTo, setSelectedTo] = useState(null); // Selected 'To' city

  useEffect(() => {
    // Initialize jQuery datepicker
    $("#departure-datepicker").datepicker({
      dateFormat: "dd M y",
      onSelect: function (dateText, inst) {
        setDepartureDate(
          inst.selectedYear +
            "-" +
            (inst.selectedMonth + 1) +
            "-" +
            inst.selectedDay
        );
      },
    });
  }, []);

  // Fetch cities dynamically
  const fetchCities = (inputValue) => {
    if (!inputValue) {
      setCities([]); // Clear list if no input
      return;
    }

    setLoading(true);

    fetch(`${baseurl}getAllCities?search=${inputValue}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.cities) {
          setCities(data.cities);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching cities:", error);
        setLoading(false);
      });
  };



  const navigate = useNavigate();


  const handleSubmit = (e) => {
  e.preventDefault();

  const formData = {
    from: selectedFrom?.value || "",
    to: selectedTo?.value || "",
    dateOfJourney: departureDate,
  };

  console.log("formData", formData);

  // Construct URL with query parameters
  const searchParams = new URLSearchParams(formData).toString();
  const searchUrl = `/bus-result?${searchParams}`;

  // Navigate to the result page with query params
  navigate(searchUrl);
};

  return (
    <>
      <AgentNavbar />
      <div className="bgsearch1">
        <div className="container bg-2 midle">
          <h1 className="text-start agenth1 font3 txt6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="40px"
              viewBox="0 -960 960 960"
              width="40px"
              fill="#000000"
            >
              <path d="M240-120v-40l60-40q-59 0-99.5-40.5T160-340v-380q0-83 77-121.5T480-880q172 0 246 37t74 123v380q0 59-40.5 99.5T660-200l60 40v40H240Zm-13.33-430h222.66v-143.33H226.67V-550ZM660-483.33H226.67h506.66H660ZM516-550h217.33v-143.33H516V-550ZM336.71-316.67q23.62 0 40.12-16.54 16.5-16.53 16.5-40.16 0-23.63-16.54-40.13-16.54-16.5-40.16-16.5-23.63 0-40.13 16.54-16.5 16.54-16.5 40.17 0 23.62 16.54 40.12 16.54 16.5 40.17 16.5Zm286.66 0q23.63 0 40.13-16.54 16.5-16.53 16.5-40.16 0-23.63-16.54-40.13-16.54-16.5-40.17-16.5-23.62 0-40.12 16.54-16.5 16.54-16.5 40.17 0 23.62 16.54 40.12 16.54 16.5 40.16 16.5ZM300-263.33h360q31.33 0 52.33-22.34 21-22.33 21-54.33v-143.33H226.67V-340q0 32 21 54.33 21 22.34 52.33 22.34Zm180-550q-108.67 0-162.83 13.66Q263-786 240-760h483.33q-18-24.67-75.83-39-57.83-14.33-167.5-14.33Zm0 53.33H723.33 240h240Z" />
            </svg>
            Search Bus
          </h1>
          
          <hr />

          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row g-3 text-start mb-3">
              {/* From Field */}
              <div className="col-md-5 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">From</label>
                <Select
                  options={cities.map((city) => ({
                    value: city.city_code,
                    label: `${city.city_name} (${city.country_name})`,
                  }))}
                  name="from"
                  placeholder="Search City"
                  value={selectedFrom}
                  onChange={setSelectedFrom}
                  onInputChange={fetchCities}
                  isSearchable
                  isLoading={loading}
                />
              </div>

              {/* To Field */}
              <div className="col-md-5 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">To</label>
                <Select
                  options={cities
                    .filter((city) => city.city_code !== selectedFrom?.value) // Exclude selected "From" city
                    .map((city) => ({
                      value: city.city_code,
                      label: `${city.city_name} (${city.country_name})`,
                    }))}
                  name="to"
                  placeholder="Search City"
                  value={selectedTo}
                  onChange={setSelectedTo}
                  onInputChange={fetchCities}
                  isSearchable
                  isLoading={loading}
                />
              </div>

              {/* Date of Journey Field */}
              <div className="col-md-2 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">
                  Date of Journey
                </label>
                <input
                  type="text"
                  id="departure-datepicker"
                  className="input2"
                  name="dateOfJourney"
                  placeholder="Select date"
                  required
                />
              </div>
            </div>

            <div>
              <button type="submit" className="submit-btn mt-3">
                Search
              </button>
            </div>
          </form>

          <hr className="mt-4" />

          <p>
            The Search Bus page allows users to find bus routes and book tickets
            effortlessly...
          </p>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default BusBook;
